"use client";

import { c as _c } from "react/compiler-runtime";
import type { PlaceholderValue } from "next/dist/shared/lib/get-img-props";
import type { StaticImageData } from "next/image";
import Image from "next/image";
import { createContext, type ImgHTMLAttributes, use } from "react";
import { withComponent } from "library/styled/withComponent";
import { DefaultImage, DefaultNextImage as DefaultNextImage___raw } from "data:text/javascript;base64,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";
export const EagerContext = createContext(false);
export const EagerImages = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <EagerContext.Provider value={true}>{children}</EagerContext.Provider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
type LoadingType = "eager" | "lazy" | "default";
export type DefaultImageProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "width" | "height" | "loading" | "alt"> & {
  ref?: React.Ref<HTMLImageElement>;
};
export const prioritizeLoading = (loading: LoadingType | undefined, defaultEager: boolean): "eager" | "lazy" | undefined => {
  if (defaultEager) return "eager";
  if (loading === "default") return undefined;
  if (loading !== undefined) return loading;
  return "lazy";
};
type BaseStaticImageProps = DefaultImageProps & {
  alt: string;
  loading?: LoadingType;
};
export type StaticImageProps = BaseStaticImageProps & ({
  src: StaticImageData;
  width?: number;
  height?: number;
  sizes?: string;
  quality?: number;
  priority?: boolean;
  placeholder?: PlaceholderValue;
  srcSet?: never;
} | {
  src: string;
  width: number;
  height: number;
  quality?: never;
  priority?: never;
  placeholder?: never;
});
export default function StaticImage(t0) {
  const $ = _c(29);
  let alt;
  let loading;
  let otherProps;
  let priority;
  let sizes;
  let src;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      src,
      alt,
      loading,
      sizes,
      quality: t1,
      priority,
      placeholder: t2,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = alt;
    $[2] = loading;
    $[3] = otherProps;
    $[4] = priority;
    $[5] = sizes;
    $[6] = src;
    $[7] = t1;
    $[8] = t2;
  } else {
    alt = $[1];
    loading = $[2];
    otherProps = $[3];
    priority = $[4];
    sizes = $[5];
    src = $[6];
    t1 = $[7];
    t2 = $[8];
  }
  const quality = t1 === undefined ? 90 : t1;
  const placeholder = t2 === undefined ? "empty" : t2;
  if (!src) {
    return null;
  }
  const defaultEager = use(EagerContext);
  let t3;
  if ($[9] !== defaultEager || $[10] !== loading) {
    t3 = prioritizeLoading(loading, defaultEager);
    $[9] = defaultEager;
    $[10] = loading;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const prioritizedLoading = t3;
  let t4;
  if ($[12] !== alt || $[13] !== otherProps || $[14] !== prioritizedLoading) {
    t4 = {
      alt,
      loading: prioritizedLoading,
      ...otherProps
    };
    $[12] = alt;
    $[13] = otherProps;
    $[14] = prioritizedLoading;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const props = t4;
  if (typeof src === "string") {
    const t5 = props.width && props.height ? `${props.width}/${props.height}` : "";
    let t6;
    if ($[16] !== props || $[17] !== sizes || $[18] !== src || $[19] !== t5) {
      t6 = <DefaultImage {...props} src={src} sizes={sizes} aspectRatio={t5} />;
      $[16] = props;
      $[17] = sizes;
      $[18] = src;
      $[19] = t5;
      $[20] = t6;
    } else {
      t6 = $[20];
    }
    return t6;
  }
  const isSVG = src.src.endsWith(".svg") || src.src.startsWith("data:image/svg+xml");
  const t5 = isSVG ? undefined : placeholder;
  const t6 = sizes ?? "100vw";
  const t7 = props.width && props.height ? `${props.width}/${props.height}` : undefined;
  let t8;
  if ($[21] !== priority || $[22] !== props || $[23] !== quality || $[24] !== src || $[25] !== t5 || $[26] !== t6 || $[27] !== t7) {
    t8 = <DefaultNextImage placeholder={t5} {...props} src={src} quality={quality} priority={priority} sizes={t6} aspectRatio={t7} />;
    $[21] = priority;
    $[22] = props;
    $[23] = quality;
    $[24] = src;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  return t8;
}
const DefaultNextImage = withComponent(Image, DefaultNextImage___raw);